
<template>
  <el-dialog
    :title="$parent.dialogName"
    :visible.sync="continueDialogVisible"
    width="70%"
    @close="close"
  >
    <div>车辆信息</div>
    <el-form ref="lease" :model="lease" :rules="rules" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="车牌号">
            <span class="value">{{ form.license_num}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="车辆型号" prop="type">
            <span class="value">{{form.type}}</span>
            <!-- <el-select
              v-model="form.type_code"
              placeholder="请选择"
              disabled="disabled"
              style="width:100%;"
            >
              <el-option
                v-for="item in options.type_code"
                :key="item.id"
                :label="item.type"
                :value="item.id"
              ></el-option>
            </el-select>-->
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="Tbox编号">
            <span class="value">{{ form.tbox_num}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="车辆品牌" prop="brand">
            <el-select
              v-model="form.brand_code"
              placeholder="请选择"
              style="width:100%;"
              disabled="disabled"
            >
              <el-option
                v-for="item in options.brand_code"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="底盘型号">
            <span class="value">{{ form.chassis}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="车牌号">
            <span class="value">{{ form.license_num}}</span>
          </el-form-item>
        </el-col>
      </el-row>-->
      <div>租赁信息</div>
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="姓名">
            <span class="value">{{ lease.name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="驾照类型" prop="driver">
            <span class="value">{{ lease.driver}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="身份证">
            <span class="value">{{ lease.card}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="驾照号码">
            <span class="value">{{ lease.driver_num}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="联系电话" prop="iphone">
            <span class="value">{{ lease.iphone}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="紧急人联系电话" prop="iphone">
            <span class="value">{{ lease.emergency_contact}}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="起租里程数">
            <span class="value">{{ lease.current_mile}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="租赁日期" prop="start_time">
            <el-date-picker
              style="width:100%;"
              :disabled="edit"
              v-model="lease.start_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="计划归还日期"  prop="specified_time">
            <el-date-picker
              style="width:52.6%;"
              :disabled="edit"
              v-model="lease.specified_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="续租日期" prop="pre_specified_time">
            <el-date-picker
              style="width:100%;"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="lease.pre_specified_time"
              type="datetime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
     
      <el-button type="primary" @click="submitForm('lease')">确认</el-button>
      <el-button @click="close">取消</el-button>
    </el-form>
  </el-dialog>
</template>
<script>
import {
  GetCarDetailes,
  getCarLeaseByCarNum,
  UpdateCarLease,
  queryCarMileage,
  reNewCarLease
} from "@/api/car";
import {
  GetDataSelectXing,
  GetdataSelectType,
  GetdataSelectCar
} from "@/api/system";
export default {
  data() {
    return {
      continueDialogVisible: true,
      edit: true,
      form: {
        name: "",
        id: ""
      },
      lease: {
        card: ""
      },
      options: {
        type_code: [],
        brand_code: [],
        model: [],
        driver: [
          { id: "A1", name: "A1" },
          { id: "A2", name: "A2" },
          { id: "A3", name: "A3" }
        ]
      },
      rules: {
        pre_specified_time: [
          { required: true, message: "必填", trigger: "blur" }
        ]
      },
      pickerOptions: {
        disabledDate: time => {
          let nowData = new Date();
          nowData = new Date(nowData.setDate(nowData.getDate() - 1));
          //let specifiedTime = new Date(this.lease.specified_time)
          return time < nowData;
        }
      }
    };
  },
  mounted() {
    this.form.id = this.$parent.childform.id;
    this.form.car_status = this.$parent.childform.type;
    this.form.frame_num = this.$parent.childform.frame_num;
    this.GetCarDetailese(this.form.id, this.form.car_status);
    this.getCarLeases(this.form.id, this.form.car_status, this.form.frame_num);
    this.GetSelect();
    this.getCarMileage();
  },
  methods: {
    GetSelect() {
      GetDataSelectXing().then(res => {
        this.options.brand_code = res.data.content;
      });
      GetdataSelectType().then(res => {
        this.options.type_code = res.data.content;
      });
      GetdataSelectCar().then(res => {
        this.options.model = res.data.content;
      });
    },
    GetCarDetailese(id, car_status) {
      GetCarDetailes({ id, car_status }).then(res => {
        this.form = res.data.content[0];
      });
    },
    getCarLeases(id, car_status, frame_num) {
      getCarLeaseByCarNum({ id, car_status, frame_num }).then(res => {
        this.lease = res.data.content[0];
      });
    },
    getCarMileage() {
      if (this.$parent.childform.tbox_num != null) {
        var snt = [this.$parent.childform.tbox_num];
        let sn = JSON.stringify(snt);
        queryCarMileage({ sn: sn }).then(res => {
          if (res.code != 1) {
            this.lease.over_mile = res.data[0].totalMileage;
          }
        });
      }
    },
    close() {
      this.$parent.continueDialogVisible = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var specified_time = new Date(this.lease.specified_time).getTime();
          var pre_specified_time = new Date(
            this.lease.pre_specified_time
          ).getTime();
          if (specified_time > pre_specified_time) {
            this.$message.error("预计回收时间不能小于计划归还时间！");
            return;
          }
          this.onSubmit();
        } else {
          return false;
        }
      });
    },
    onSubmit() {
      const data = {
        id: this.lease.carleaseId,
        specified_time: this.lease.pre_specified_time
      };
      reNewCarLease(data).then(res => {
        if (res.code !== 0) {
          this.$message.error(res.message);
          return;
        }
        this.$message.success("保存成功!");
        this.close();
        this.$parent.search();
      });
    }
  }
};
</script>

<style lang="less" scoped>
</style>